import type { ReactNode } from "react";

export function Switch({ children }) {
  for (const child of children) {
    if (child?.props?.expr) {
      return child;
    }
  }

  return null;
}

export function Case({ children }: { children: ReactNode; expr: boolean }) {
  return <div>{children}</div>;
}
